import React from 'react';
import SelectDesignPage from './SelectDesignPage';

const SelectDesign = () => {
  return <SelectDesignPage />;
};

export default SelectDesign;